module.exports = __webpack_public_path__ + "img/ui_base_create.b9c3a539.png";